import { ClientAdditional, ClientExtra, ClientProduct } from "../types/product";
import {
  ApiAdditional,
  ApiExtra,
  ApiProduct,
} from "../types/product/api-types";

const mapAdditional = (
  additional?: ApiAdditional[],
): ClientAdditional[] | undefined => {
  return additional?.map((item) => ({
    id: item.id,
    name: item.name,
    price: item.price,
    imageUrl: item.image_url,
  }));
};

const mapExtra = (extra?: ApiExtra[]): ClientExtra[] | undefined => {
  return extra?.map((item) => ({
    id: item.id,
    name: item.name,
    price: item.price,
  }));
};

export const productAdapter = {
  toClient(apiProduct: ApiProduct): ClientProduct {
    return {
      id: apiProduct.id,
      name: apiProduct.name,
      price: apiProduct.price,
      description: apiProduct.description,
      imageUrl: apiProduct.image_url,
      weight: apiProduct.weight,
      additional: mapAdditional(apiProduct.additional),
      extra: mapExtra(apiProduct.extra),
    };
  },
};
